import React from "react";

import Container from "@material-ui/core/Container";
import { connect } from "react-redux";
import {
  useEntityProgress,
  useMasterDetailWithDialog,
  useSortHandler,
} from "reactcoregk/hooks";
import Grid from "@material-ui/core/Grid";
import Pagination from "@material-ui/lab/Pagination";
import Box from "@material-ui/core/Box";
import SubmenuLayout from "../../components/Layouts/SubmenuLayout";
import ActorsTable from "./ActorsTable";
import { createActor, getAllActors } from "../../store/actor/actions";
import Menu from "./Menu";
import {
  useApi,
  useCurrentPageParam,
  useDefaultTable,
  usePageableEntity,
  useSortHandlerPath,
  useTableCells,
} from "../../helpers/hooks";
import { Schema } from "../../store/@core/schema";
import { EntityType } from "../../store/@core/entityType";
import EditDialog from "./EditDialog";
import TableSettingsDialog from "components/Common/TableSettingsDialog";
import { tableSettingKeys } from "constants/enums";
import { useState } from "react";

const defaultCells = [
  {
    id: "actorId",
    disablePadding: false,
    label: "Actor unique ID",
    default: true,
    isSortable: true,
  },
  {
    id: "name",
    disablePadding: false,
    label: "Name",
    default: false,
  },
  {
    id: "firstActivityDate",
    disablePadding: false,
    label: "First Activity Date",
    default: false,
  },
  {
    id: "lastActivityDate",
    disablePadding: false,
    label: "Last Activity Date",
    default: false,
  },
  {
    id: "actorType",
    disablePadding: false,
    label: "Actor Type",
    default: false,
  },
  {
    id: "knownAs",
    disablePadding: false,
    label: "Known as",
    default: false,
  },
  {
    id: "capability",
    disablePadding: false,
    label: "Capability",
    default: false,
  },
  {
    id: "motivations",
    disablePadding: false,
    label: "Motivations",
    default: false,
  },
  {
    id: "cves",
    disablePadding: false,
    label: "CVES",
    default: false,
  },
  {
    id: "origins",
    disablePadding: false,
    label: "Origins",
    default: false,
  },
  {
    id: "targetedLocations",
    disablePadding: false,
    label: "Targeted Location",
    default: false,
  },
  {
    id: "targetIndustries",
    disablePadding: false,
    label: "Targeted Industries",
    default: false,
  },
  {
    id: "lastUpdatedAt",
    disablePadding: false,
    label: "Last Updated At",
    default: false,
  },
];

function Actors(props) {
  const { context, getAllActors, createActor } = props;
  const sortHandler = useSortHandler();

  const errorMessage = context.Actor.getAllPageable.error;
  const verticals = context.CompanyVertical.getAll.result;
  const countries = context.Country.getAll.result;
  // Handle search parameters for pagination
  const rootParams = props.location.search.replace("?", "&");

  const { list, isLoading, totalPages } = usePageableEntity(
    context.Actor,
    getAllActors,
    rootParams
  );

  const [openSettings, setOpenSettings] = useState(false);

  const [state, loading] = useApi("/actors/distinct/values");

  // Refresh table after a successful post
  useEntityProgress(context.Actor, () => getAllActors());

  const { cells, storedCells, optionalCellRender } = useTableCells(
    context,
    tableSettingKeys.ACTORS,
    defaultCells,
    false
  );

  const [currentPage, setCurrentPage] = useCurrentPageParam();

  useSortHandlerPath(sortHandler.sort, "id");

  const { openModal, handleCreateNew, handleCloseModal, entity } =
    useMasterDetailWithDialog(Schema[EntityType.Actor]);

  const defaultTable = useDefaultTable(list, sortHandler, "actorId");

  const MenuItemsComponent = (
    <Menu
      selected={defaultTable.selected}
      handleCreateNew={handleCreateNew}
      distinctValues={state}
      verticals={verticals}
      countries={countries}
      openSettings={() => setOpenSettings(true)}
    />
  );

  return (
    <SubmenuLayout
      noDivider
      MenuItemsComponent={MenuItemsComponent}
      title={"Actors"}
      errorMessage={errorMessage}
    >
      <Container maxWidth={false}>
        <ActorsTable
          actors={list}
          optionalCellRender={optionalCellRender}
          headCells={cells}
          isLoading={isLoading}
          defaultTable={defaultTable}
          handleEntityClick={(entity) => {
            props.history.push("/actors/" + entity.actorId);
          }}
        />
      </Container>
      <Box mt={2} component={Grid} container justify={"center"}>
        <Pagination
          onChange={(e, newPage) => setCurrentPage(newPage - 1)}
          page={currentPage}
          count={totalPages}
          showFirstButton
          showLastButton
          size={"small"}
        />
      </Box>
      <EditDialog
        entity={entity}
        context={context.Actor}
        createEntity={createActor}
        open={openModal}
        countries={countries}
        verticals={verticals}
        entityType={EntityType.Actor}
        handleClose={handleCloseModal}
      />
      <TableSettingsDialog
        open={openSettings}
        handleClose={() => setOpenSettings(false)}
        storedCells={storedCells}
        defaultCells={defaultCells}
        tableKey={tableSettingKeys.ACTORS}
      />
    </SubmenuLayout>
  );
}

const mapStateToProps = (state) => {
  return {
    context: state,
  };
};
export default connect(mapStateToProps, {
  getAllActors,
  createActor,
})(Actors);
